function getConfiguredApiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_URL;
  return typeof configured === 'string' ? configured.trim() : '';
}

function shouldUseConfiguredApiBaseUrl(): boolean {
  if (import.meta.env.DEV) {
    return true;
  }

  return import.meta.env.VITE_FORCE_CROSS_ORIGIN_API === 'true';
}

export function resolveBrowserApiBaseUrl(): string {
  const configuredApiBaseUrl = getConfiguredApiBaseUrl();
  if (!configuredApiBaseUrl) {
    return '';
  }

  if (shouldUseConfiguredApiBaseUrl()) {
    return configuredApiBaseUrl;
  }

  return '';
}

export function resolveBrowserApiUrl(path: string): string {
  const apiBaseUrl = resolveBrowserApiBaseUrl();
  if (apiBaseUrl) {
    return new URL(path, apiBaseUrl).toString();
  }

  if (typeof window === 'undefined') {
    return path;
  }

  return new URL(path, window.location.origin).toString();
}
